// View More button on Single Program

const ViewMore = ( $ ) => {

	// show/hide program details on mobile
	$("#view-more-button").on("click", function () {

		// toggle button text on click
		if ($(this).html() === "View More") {
			$("#view-more-button").html('View Less')
		} else {
			$("#view-more-button").html('View More')
		}

		// toggles the hidden program details
		$(".js-click-to-view").slideToggle()
	})


	// make sure sections are visible on desktop
	$(window).resize(function() {
		let windowSize = $(window).width();
		if (windowSize > 1024) {
			$(".js-click-to-view").show();
		} else {
			$(".js-click-to-view").hide();
		}

		// check button text
		if ($(".js-click-to-view").is(":visible")) {
			$("#view-more-button").html('View Less')
		} else {
			$("#view-more-button").html('View More')
		}
	});
}

export default ViewMore;
